import React, { useState } from 'react';
import { Container, Card, CardGroup, Modal, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import './styles/CasosDeExito.css';
import Cel from '../archivos/CasosDeExitoImg/Ejemplo Celu.png';
import { casosActions } from '../service';

import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import { useEffect } from 'react';

function CasosExito(props) {
	const { t, i18n } = props;
	const [openModal, setOpen] = useState(false);
	const [casos, setCasos] = useState();

	useEffect(() => {
		casosActions.get().then(res => setCasos(res))
	}, []);

	return (
		<>
			<button className='btnCasos' onClick={() => setOpen(!openModal)}>
				{t('clientes.btnCasos')}
			</button>
			<Modal
				className='modalCasos'
				show={openModal}
				size='xl'
				aria-labelledby='contained-modal-title-vcenter'
				centered
			>
				<Modal.Header className='modal-header'>
					<Button className='close' onClick={() => setOpen(!openModal)}>
						+
					</Button>
				</Modal.Header>
				<Modal.Body className='modal-bodyCasos'>
					<Swiper
						rewind={true}
						navigation={true}
						spaceBetween={100}
						modules={[Navigation, Pagination]}
						className='mySwiper'
					>
						{casos?.map((e) => {
							return (
								<SwiperSlide key={e._id} className='slideCasos'>
									<div className='scroll'>
										<div className='casosText'>
											<h3 className='slideCasosh3'>{t("Caso.tituloModal")}</h3>
											<h2>{i18n.language === 'es' ? e.title.es : e.title.en}</h2>
											<p>{i18n.language === 'es' ? e.need.es : e.need.en}</p>
											{/* <p>
												<span>{t('Casos.Need')} </span>

												{i18n.language === 'es' ? e.need.es : e.need.en}
											</p>
											<p>
												<span>{t('Casos.Solution')} </span>
												{i18n.language === 'es' ? e.solution.es : e.solution.en}
											</p> */}
										</div>
										<div className='imgContainer'>
											{e.link ? (
												<a href={e.link} target="_black" rel='nooponer noreferrer'>
													<img className='imgCasos' src={e.imgUrl} alt='Imagen de celular con estadísticas' />
												</a>
											) : (
												<img className='imgCasos' src={e.imgUrl} alt='Imagen de celular con estadísticas' />
											)}
										</div>
									</div>
									{/* <div style={{ visibility: 'hidden' }}> x </div> */}
								</SwiperSlide>
							);
						})}
					</Swiper>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default withTranslation()(CasosExito);
